<template>
  <main class="login-page">
    <div class="header-text">
      Nordomatic Service Online
    </div>

    <div class="container">
      <div id="prForm"
           class="form"
      >
        <transition>
          <form v-show="type == 'SignIn'"
                :key="'signInForm'"
                action="#"
                class="login-form"
                @submit.prevent="login(username, password)"
          >
            <MainInput :text="username"
                       type="text"
                       name="username"
                       :placeholder="$t('loginPage.email')"
                       @value-changed="setUsername"
            />
            <MainInput :text="password"
                       type="password"
                       name="password"
                       :placeholder="$t('loginPage.password')"
                       @value-changed="setPassword"
            />
            <MainButton :button-text="$t(`loginPage.login`)"
                        type="submit"
                        style="height:50px;margin-bottom:1rem;"
            />

            <div style="color: white; margin-top: 10px;">
              {{ $t("loginPage.infoText2", {email: companyEmail, phone: companyPhone}) }}
              <br><br>
              {{ $t("loginPage.infoText", {email: companyEmail, phone: companyPhone}) }}
            </div>
            <br>
            <div style="color: white; margin-top: 6px;">
              <p>
                <a style="color: white;"
                   :href="$t('loginPage.customerGuideFileName')"
                   :download="$t('loginPage.customerGuideFileName')"
                >
                  {{ $t("loginPage.downloadGuide") }}
                </a>
              </p>
            </div>

            <div style="margin-top: 6px;">
              <a type="submit"
                 style="color: white;"
                 class="forgot-password-link"
                 @click="handleForgotPassword"
              >{{ $t("loginPage.forgotPassword") }}</a>
            </div>
          </form>
        </transition>
        <transition>
          <form v-show="type == 'ForgotPassword'"
                :key="'forgotPasswordForm'"
                action="#"
                class="passwordReset-form"
                @submit.prevent="resetPasswordClick"
          >
            <MainInput :text="username"
                       type="text"
                       name="email"
                       :placeholder="$t('loginPage.email')"
                       @value-changed="setUsername"
            />
            <MainButton :button-text="$t(`loginPage.resetPassword`)"
                        type="submit"
                        style="height:50px;margin-bottom:1rem;"
            />
            <a type="submit"
               class="forgot-password-link"
               @click="handleForgotPassword"
            >{{ $t("loginPage.backToLogin") }}</a>
          </form>
        </transition>
      </div>
    </div>
  </main>
</template>

<script setup>
import { useStore } from 'vuex'
import { computed } from 'vue'
import MainButton from '@/components/buttons/MainButton.vue'
import MainInput from '@/components/inputs/MainInput.vue'
// VueX
const store = useStore()
const username = computed(() => store.state.login.username)
const password = computed(() => store.state.login.password)
const type = computed(() => store.state.login.type)
const companyEmail = computed(() => window.apiConfig.COMPANYEMAIL)
const companyPhone = computed(() => window.apiConfig.COMPANYPHONE)
const setUsername = (x) => store.commit('login/setUsername', x.target.value)
const setPassword = (x) => store.commit('login/setPassword', x.target.value)
const login = () => store.dispatch('login/handleLoginSubmit')

const handleForgotPassword = () => store.dispatch('login/handleForgotPassword')

const resetPasswordClick = () => store.dispatch('login/resetPassword')

</script>
<style lang="scss" scoped>

.login-page {
  height: 100vh; /* Full viewport height */
  display: flex;
  flex-direction: column;
  justify-content: flex-start; /* Align content to the top */
  align-items: center; /* Center content horizontally */
}

.header-text {
  font-size: 3rem;
  font-weight: bold;
  text-align: center;
  margin-top: 2rem; /* Add some space above the header */
  color: var(--mainBlue);
  z-index: 2; /* Ensure the header text stays on top */
}

.container {
  position: relative;
  top: 10%;
  width: 565px; /* Set your container width */
  max-width: 100%;
  z-index: 1; /* Ensure the container stays below the header text */
}
.passwordReset-form {
  width: 100% !important;
}

#prForm {
  max-width: 500px;
  width: 492px;
}

.form .btn[data-v-26084dc2] {
  margin: 25px 0px 15px 0px;
}

.forgot-password-link {
  cursor: pointer;
  text-decoration: underline;
  color: white;
}
.forgot-password-link:hover {
  color: white;
}

.offline-message-link {
  cursor: pointer;
  text-decoration: underline;
  color: white;
  display: block;
  margin-top: 1rem;
}

.offline-message-form {
  background: linear-gradient(90deg, var(--gray) 0%, var(--background2) 10px);
}

.offline-message-link:hover {
  color: white;
}
.form {
  position: relative;
  z-index: 1;
  max-width: 350px;
  margin: 0 auto 100px;
  padding: 45px;
  background: var(--mainBlue);
  border-radius: 20px;
}

.form .register-form {
  display: none;
}

@media (max-width: 768px) {
  .header-text {
    font-size: 2rem; /* Adjust header size for smaller screens */
    margin-top: 1rem; /* Adjust top margin for smaller screens */
  }

  .container {
    position: relative; /* Change container to be relative on smaller screens */
    top: 5%; /* Adjust top positioning for smaller screens */
    width: 90%; /* Make container width responsive */
  }

  .form {
    position: relative;
    z-index: 1;
    max-width: 250px;
    margin: 0 auto 100px;
    padding: 25px;
    border-radius: 20px;
  }
}
</style>
